module.exports = __webpack_public_path__ + "img/reset_doorbell_step_1.24d9cbd2.png";